import _ from 'lodash';
import React, { useContext } from 'react';
import { Button } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { FormContext } from 'blaze-form';
import PropTypes from 'prop-types';
import { modal } from '../../modal/ModalEmitter';
import { getListItemId } from '../../../util/form';

const crudConfig = {
  add: {
    title: 'Add',
    render: 'listEditItem',
    variant: 'success',
    icon: 'far fa-plus',
    action: 'new',
    className: 'add',
  },
  edit: {
    title: 'Edit',
    render: 'listEditItem',
    variant: 'primary',
    icon: 'fal fa-pen',
    action: 'edit',
    className: 'edit',
  },
};

const getConfig = helper => {
  if (crudConfig[helper.action]) {
    return {
      ...crudConfig[helper.action],
      ...helper,

      // TODO Bad design, crudConfig and helper both have action keys
      // We want helper to be able to override config except for action
      action: crudConfig[helper.action].action || helper.action,
    };
  }

  return helper;
};

const FormHelperCrud = ({ helper, value, blurValue, setValue = () => {}, callback }) => {
  const { branch, permissions } = useSelector(state => state.app.user);
  const { manager } = useContext(FormContext);

  const currentPerms = permissions && branch ? permissions[branch.id] || {} : {};

  // No permissions for this page/model
  if (helper.pageName && !currentPerms[helper.pageName]) {
    return null;
  }

  const helperConfig = getConfig(helper);

  const { variant, icon, title, render, action, className } = helperConfig;

  const what = helper.action === 'add' ? 'New' : value;
  const disabled = helper.action === 'edit' && value === '';
  const derivedValue = getListItemId(value);

  const query = helper.action === 'add' ? { itemid: derivedValue } : {};
  if (helper.copy && helper.copy.length) {
    const formLookup = manager.getData();
    helper.copy.forEach(copyThis => {
      const key = Object.keys(copyThis)[0];
      const value = copyThis[key];

      if (/^\$__/.test(value)) {
        const lookupVar = value.replace('$__', '');
        if (formLookup[lookupVar]) {
          query[key] = formLookup[lookupVar].data;
          return;
        }
      }

      query[key] = copyThis[key];
    });
  }

  const onClick = () => {
    modal.open(render, {
      action,
      dialogClass: 'fitted',
      headerClass: 'primary',
      hideFooter: true,
      hidePrint: true,
      itemName: helper.pageName,
      lookupKey: helper.action === 'add' ? '' : derivedValue,
      query,
      render,
      title: `${title} ${what}`,
      submitCallback: response => {
        if (helper.action === 'add') {
          const newId = _.get(response, 'data.responses.0.itemid');
          if (newId) {
            if (blurValue) {
              blurValue(newId);
            } else {
              setValue(newId);
            }
          }
        }

        if (callback) {
          callback(response);
        }
      },
    });
  };

  if (disabled) {
    return null;
  }

  return (
    <Button
      key={helper.action}
      variant={variant}
      size="xs"
      disabled={disabled}
      className={className}
      onClick={onClick}
      title={title}
      tabIndex="-1"
    >
      <i className={`${icon} fa-fw`} />
    </Button>
  );
};

FormHelperCrud.propTypes = {
  blurValue: PropTypes.func,
  helper: PropTypes.any,
  setValue: PropTypes.func,
  value: PropTypes.any,
};

export default FormHelperCrud;
